import { ClipLoader } from "react-spinners";
import { cn } from "app/lib/utils";

interface LoadingSpinnerProps {
  readonly size?: number;
  readonly message?: string;
  readonly subMessage?: string;
  readonly className?: string;
}

/**
 * LoadingSpinner component displays a centered loading spinner with optional messages.
 *
 * @param size - Size of the spinner in pixels (default: 48)
 * @param message - Primary loading message (bold)
 * @param subMessage - Secondary message below the primary message
 * @param className - Additional CSS classes for the container
 */
export default function LoadingSpinner({
  size = 48,
  message,
  subMessage,
  className,
}: LoadingSpinnerProps) {
  return (
    <div className={cn("flex flex-col items-center gap-4", className)}>
      <div className="flex justify-center items-center">
        <ClipLoader color="#53565A" size={size} speedMultiplier={0.5} />
      </div>
      {message && (
        <p className="font-bold text-base leading-6 text-black m-0 min-w-fit">
          {message}
        </p>
      )}
      {subMessage && (
        <p className="font-normal text-sm leading-5 text-black m-0 min-w-fit">
          {subMessage}
        </p>
      )}
    </div>
  );
}
